(() => {
  const navigateTo = (url) => {
    if (!url) return;
    window.location.href = url;
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    // Radio/button/swatch pickers
    if (target.matches('[data-siblings-picker] input[type="radio"][data-sibling-url]')) {
      const input = /** @type {HTMLInputElement} */ (target);
      if (!input.checked) return;
      navigateTo(input.getAttribute('data-sibling-url'));
      return;
    }

    // Dropdown picker
    if (target.matches('[data-siblings-picker] select[data-siblings-select]')) {
      const select = /** @type {HTMLSelectElement} */ (target);
      const selectedOption = select.selectedOptions && select.selectedOptions[0];

      // Update swatch preview if present (navigation happens right after)
      if (selectedOption) {
        const swatch = selectedOption.getAttribute('data-sibling-swatch-value');
        const focalPoint = selectedOption.getAttribute('data-sibling-swatch-focal-point');
        const swatchEl = select.closest('[data-siblings-picker]')?.querySelector('.dropdown-swatch .swatch');

        if (swatchEl && swatch) {
          const styleParts = [`--swatch--background: ${swatch};`];
          if (focalPoint) styleParts.push(`--swatch-focal-point: ${focalPoint};`);
          swatchEl.setAttribute('style', styleParts.join(''));
          swatchEl.classList.remove('swatch--unavailable');
        }
      }

      navigateTo(select.value);
    }
  });
})();
